var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',{attrs:{"label":`I am willing to relocate internationally`,"color":_vm.themes.candidate.light.input},on:{"change":_vm.submit},model:{value:(_vm.profile.willingToRelocateInternationally),callback:function ($$v) {_vm.$set(_vm.profile, "willingToRelocateInternationally", $$v)},expression:"profile.willingToRelocateInternationally"}})
}
var staticRenderFns = []

export { render, staticRenderFns }